/**
 * This object contains all feature flags providers
 */
export var FEATURE_FLAGS_PROVIDERS = {
  DIVE_PROVIDER: 'DiveFeatureFlagsProvider',
  ALWAYS_TURE_PROVIDER: 'AlwaysTrueFeatureFlagsProvider'
};